import "./home.css";
import Arrow from "../../assets/images/icons/Icon-Freccia-menu.svg";
import Help from "../../assets/images/pulsante_help_bn.png";

import { Link } from "react-router-dom";
import AppText from "../_shared/components/AppText";
import splashScreen from "../../assets/splash.png";
import { useState } from "react";

function Home(props) {
  function getTitleRow(title, subTitle, link) {
    return (
      <div className="card">
        <Link className="row" to={link}>
          <div style={{ display: "flex" }}>
            <img
              alt=""
              src={Arrow}
              className="arrow"
              style={{
                height: 30,
                width: 20,
                marginRight: 10,
                alignSelf: "center",
                justifyContent: "center",
              }}
            ></img>
          </div>
          <div>
            <AppText big bold>
              {title}
            </AppText>
            <AppText>{subTitle}</AppText>
          </div>
        </Link>
      </div>
    );
  }
  return (
    <div className="rootHome">
      <div>
        {getTitleRow("il sistema", "the system", "/system")}
        <div className="row">
          {getTitleRow("ambienti", "rooms", "/rooms")}
          {getTitleRow("prodotti", "products", "/products")}
          {getTitleRow(
            "finiture, tessuti, maniglie",
            "finishes, fabrics, handles",
            "/finishes"
          )}
        </div>

        <div className="row" style={{ marginTop: "20%" }}>
          {getTitleRow("scarica", "downloads", "/downloads")}
          {getTitleRow("video tecnici", "technical videos", "/videos")}
        </div>
        <Link className="helpIcon row" to={"/help"}>
          
           <img src={Help} alt=""   style={{
                height: 60,
                width: 60,
                marginRight: 10,
                alignSelf: "center",
                justifyContent: "center",
              }}></img> 
        </Link>
      </div>
    </div>
  );
}

export default Home;
